export { default as Img200 } from './processed/200/Book-Of-Love-The.jpg';
export { default as Img400 } from './processed/400/Book-Of-Love-The.jpg';
export { default as Imgthumb } from './processed/thumb/Book-Of-Love-The.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Book-Of-Love-The.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Book-Of-Love-The.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      20,
      196,
      236
    ],
    "_population": 5789,
    "_hsl": [
      0.5308641975308642,
      0.8503937007874016,
      0.5019607843137255
    ]
  },
  "LightVibrant": {
    "_rgb": [
      101,
      205,
      232
    ],
    "_population": 4476,
    "_hsl": [
      0.5343511450381678,
      0.7401129943502822,
      0.6529411764705882
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      37,
      151,
      192
    ],
    "_population": 48,
    "_hsl": [
      0.5440860215053763,
      0.6768558951965065,
      0.44901960784313727
    ]
  },
  "Muted": {
    "_rgb": [
      172,
      92,
      100
    ],
    "_population": 1,
    "_hsl": [
      0.9833333333333334,
      0.32520325203252043,
      0.5176470588235295
    ]
  },
  "LightMuted": {
    "_rgb": [
      197,
      175,
      165
    ],
    "_population": 838,
    "_hsl": [
      0.052083333333333294,
      0.2162162162162162,
      0.7098039215686275
    ]
  },
  "DarkMuted": {
    "_rgb": [
      36,
      42,
      54
    ],
    "_population": 5055,
    "_hsl": [
      0.611111111111111,
      0.2,
      0.1764705882352941
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Book-Of-Love-The.js